module.exports = __webpack_public_path__ + "img/line-chart-dark-01.5a45399d.jpg";